/*
export const someAction = (state) => {}
 */
export var setDrawerData = function setDrawerData(state, data) {
  state.commit('setDrawerData', data);
};
export var clearDrawerData = function clearDrawerData(state, data) {
  state.commit('clearDrawerData', data);
};